import { get, isUndefined } from 'lodash-es'

import API_CONSTANTS from '@/js/helper/api-constants.js'

import SERVICE_CONSTANTS from '@/js/helper/aimeos-service-constants.js'

import SERVICE_GETTER_TYPES from '../getter-types/service-getter-types'
import CHECKOUT_GETTER_TYPE from '../getter-types/checkout-getter-types'

import { getRelatedIncludes } from '@/js/helper/relationships-helper.js'

const processServices =
  ({ type, getters }) =>
  services =>
    services
      .filter(service => get(service, SERVICE_CONSTANTS.PATHS.TYPE) === SERVICE_CONSTANTS.ID[type])
      .filter(service =>
        SERVICE_CONSTANTS.CODE[type].includes(get(service, SERVICE_CONSTANTS.PATHS.CODE)),
      )
      .sort(
        (a, b) => SERVICE_CONSTANTS.CODE[type].indexOf(a) - SERVICE_CONSTANTS.CODE[type].indexOf(b),
      )
      .map(service => {
        const texts = getRelatedIncludes({
          relationships: get(service, [API_CONSTANTS.RELATIONSHIPS]),
          included: getters[SERVICE_GETTER_TYPES.SERVICE_INCLUDED],
          type: API_CONSTANTS.AIMEOS.TYPE.TEXT,
        })
        return {
          ...service,
          texts,
        }
      })

const formatService = service => {
  const text = get(service, 'texts', []).find(
    item => get(item, API_CONSTANTS.AIMEOS.TEXT.PATHS.TYPE) === SERVICE_CONSTANTS.TEXT_TYPE.NAME,
  )
  return {
    id: get(service, SERVICE_CONSTANTS.PATHS.ID),
    code: get(service, SERVICE_CONSTANTS.PATHS.CODE),
    label: text
      ? get(text, API_CONSTANTS.AIMEOS.TEXT.PATHS.CONTENT)
      : get(service, SERVICE_CONSTANTS.PATHS.LABEL) || get(service, SERVICE_CONSTANTS.PATHS.CODE),
  }
}

const basketService = type => (state, getters) => {
  const service = getters[SERVICE_GETTER_TYPES[`SERVICE_${type}_SERVICES`]].find(
    service => get(service, API_CONSTANTS.ID) === getters[CHECKOUT_GETTER_TYPE[`${type}_SERVICE`]],
  )
  if (isUndefined(service)) {
    return undefined
  }
  return {
    [API_CONSTANTS.ID]: SERVICE_CONSTANTS.ID[type],
    [API_CONSTANTS.ATTRIBUTES]: {
      [SERVICE_CONSTANTS.ATTRIBUTE.ID]: getters[CHECKOUT_GETTER_TYPE[`${type}_SERVICE`]],
    },
  }
}

const serviceCode = type => (state, getters) => {
  const service = getters[SERVICE_GETTER_TYPES[`SERVICE_${type}_SERVICES`]].find(
    service => get(service, API_CONSTANTS.ID) === getters[CHECKOUT_GETTER_TYPE[`${type}_SERVICE`]],
  )
  if (isUndefined(service)) {
    return undefined
  }
  return get(service, SERVICE_CONSTANTS.PATHS.CODE)
}

export const getServiceGetters = REQUEST_TYPES => ({
  [SERVICE_GETTER_TYPES.SERVICE_DATA]: state =>
    get(state, [REQUEST_TYPES.SERVICE.dataKey, API_CONSTANTS.DATA], []),
  [SERVICE_GETTER_TYPES.SERVICE_INCLUDED]: state =>
    get(state, [REQUEST_TYPES.SERVICE.dataKey, API_CONSTANTS.INCLUDED], []),
  [SERVICE_GETTER_TYPES.SERVICE_DELIVERY_SERVICES]: (state, getters) =>
    processServices({ type: 'DELIVERY', getters })(getters[SERVICE_GETTER_TYPES.SERVICE_DATA]),
  [SERVICE_GETTER_TYPES.SERVICE_PAYMENT_SERVICES]: (state, getters) =>
    processServices({ type: 'PAYMENT', getters })(getters[SERVICE_GETTER_TYPES.SERVICE_DATA]),
  [SERVICE_GETTER_TYPES.SERVICE_PAYMENT_SERVICES_FORMATTED]: (state, getters) =>
    getters[SERVICE_GETTER_TYPES.SERVICE_PAYMENT_SERVICES].map(formatService),
  [SERVICE_GETTER_TYPES.SERVICE_DELIVERY_SERVICES_FORMATTED]: (state, getters) =>
    getters[SERVICE_GETTER_TYPES.SERVICE_DELIVERY_SERVICES].map(formatService),
  [SERVICE_GETTER_TYPES.SERVICE_SELECTED_PAYMENT_SERVICES_FORMATTED]: (state, getters) =>
    getters[SERVICE_GETTER_TYPES.SERVICE_PAYMENT_SERVICES_FORMATTED].find(
      service => service[API_CONSTANTS.ID] === getters[CHECKOUT_GETTER_TYPE.PAYMENT_SERVICE],
    ),
  [SERVICE_GETTER_TYPES.SERVICE_SELECTED_DELIVERY_SERVICES_FORMATTED]: (state, getters) =>
    getters[SERVICE_GETTER_TYPES.SERVICE_DELIVERY_SERVICES_FORMATTED].find(
      service => service[API_CONSTANTS.ID] === getters[CHECKOUT_GETTER_TYPE.DELIVERY_SERVICE],
    ),
  [SERVICE_GETTER_TYPES.SERVICE_PAYMENT_SERVICE_BASKET]: basketService('PAYMENT'),
  [SERVICE_GETTER_TYPES.SERVICE_DELIVERY_SERVICE_BASKET]: basketService('DELIVERY'),
  [SERVICE_GETTER_TYPES.SERVICE_PAYMENT_SERVICE_CODE]: serviceCode('PAYMENT'),
  [SERVICE_GETTER_TYPES.SERVICE_DELIVERY_SERVICE_CODE]: serviceCode('DELIVERY'),
})
